import { Container } from "@material-ui/core";

import { colors } from "../../../values";

import { Ic_delivery_white, Ic_payment_white, Ic_products_white, Ic_delivery, Ic_payment, Ic_products } from "values";

const Item = ({ title = "", active = false, setSteps, src1, src2 }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
      <div
        onClick={() => setSteps()}
        style={{
          height: 56,
          width: 56,
          borderRadius: "99.99%",
          backgroundColor: active ? colors.front : colors.gray,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img alt="" src={active ? src1 : src2} style={{ width: 24, height: 24 }} />
      </div>
      <p style={{ fontSize: 12, position: "absolute", bottom: -45, textAlign: "center", whiteSpace: "nowrap", fontFamily: "m_semi_bold" }}>{title}</p>
    </div>
  );
};

const Divider = ({ active = false }) => {
  return <div style={{ height: 2, width: 200, backgroundColor: !active ? colors.gray : colors.front }} />;
};

const Header = ({ steps, setSteps }) => {
  return (
    <Container>
      <div style={{ display: "flex", alignItems: "center", gap: 16, justifyContent: "center", marginBottom: 100 }}>
        <Item title="PRODUCTOS" active={steps >= 1} setSteps={() => setSteps(1)} src1={Ic_products_white} src2={Ic_products} />
        <Divider active={steps >= 1} />
        <Item title="INFORMACIÓN DE ENVIO" active={steps >= 2} setSteps={() => setSteps(2)} src1={Ic_delivery_white} src2={Ic_delivery} />
        <Divider active={steps >= 2} />
        <Item title="PAGO" active={steps >= 3} setSteps={() => {}} src1={Ic_payment_white} src2={Ic_payment} />
      </div>
    </Container>
  );
};

export default Header;
